import request from '@/utils/http';

// 支付记录 分页查询
const queryPage = data => {
    return request({
        url: `/api-antms/query/carrier/pay/record/queryByPage`,
        method: 'post',
        data
    });
};
// 支付记录 总数查询
const queryCount = data => {
    return request({
        url: `/api-antms/query/carrier/pay/record/queryCount`,
        method: 'post',
        data
    });
};
// 支付记录 更新状态
const updatePayStatus = data => {
    return request({
        url: `/api-antms/billing/carrier/settlement/updatePayStatus`,
        method: 'post',
        data
    });
};
// 包含的分帐单
const queryDivideDtoByPage = data => {
    return request({
        url: `/api-antms/query/carrier/pay/record/queryDivideDtoByPage`,
        method: 'post',
        data
    });
};
export {
    queryPage,
    queryCount,
    updatePayStatus,
    queryDivideDtoByPage
};